var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      style: _vm.modalStyle,
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        forceRender: true,
        fullscreen: "",
        switchFullscreen: "",
        wrapClassName: "ant-modal-cust-warp",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      !_vm.designerVisible
        ? _c("div", { staticClass: "top-toolbar" }, [
            _c(
              "div",
              {
                staticClass: "toolbar-left",
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  gap: "8px",
                },
              },
              [
                _c(
                  "a-button",
                  {
                    key: "templateSetting",
                    attrs: { icon: "setting", disabled: _vm.autoPrint },
                    on: { click: _vm.handleTemplateSetting },
                  },
                  [_vm._v("模板设置")]
                ),
                _c(
                  "a-button",
                  {
                    key: "printPreview",
                    attrs: { type: "primary", icon: "printer" },
                    on: { click: _vm.handlePrintPreview },
                  },
                  [_vm._v("打印预览")]
                ),
                _c(
                  "a-button",
                  {
                    key: "exportPdf",
                    attrs: { icon: "file-pdf" },
                    on: { click: _vm.handleExportPdf },
                  },
                  [_vm._v("导出PDF")]
                ),
                _c(
                  "a-checkbox",
                  {
                    on: { change: _vm.onAutoPrintChange },
                    model: {
                      value: _vm.autoPrint,
                      callback: function ($$v) {
                        _vm.autoPrint = $$v
                      },
                      expression: "autoPrint",
                    },
                  },
                  [_vm._v("自动")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("template", { slot: "footer" }, [
        _c("div", { staticClass: "footer-bar" }, [
          _c(
            "div",
            { staticClass: "footer-right" },
            [
              _c("a-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      !_vm.designerVisible
        ? _c(
            "a-spin",
            { attrs: { spinning: _vm.loading, tip: "正在加载模板..." } },
            [
              _c("div", { staticClass: "hiprint-container" }, [
                !_vm.templateJson && !_vm.loading
                  ? _c(
                      "div",
                      { staticClass: "no-template" },
                      [
                        _c(
                          "a-empty",
                          { attrs: { description: "暂无打印模板" } },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.handleTemplateSetting },
                              },
                              [_vm._v("去设置模板")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "preview-wrapper" }, [
                      _c("div", {
                        ref: "printContent",
                        staticClass: "print-content",
                        style: {
                          transform: `scale(${_vm.zoomLevel / 100})`,
                          transformOrigin: "top center",
                        },
                      }),
                    ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.designerVisible
        ? _c(
            "div",
            { staticClass: "designer-wrapper" },
            [
              _c("EmbeddedDesigner", {
                ref: "embeddedDesigner",
                attrs: {
                  billType: _vm.billTypeCode,
                  billTypeName: _vm.billType,
                  billNo: _vm.currentBillNo,
                  templateId: _vm.selectedTemplateId,
                  billData: _vm.printData,
                },
                on: { close: _vm.onDesignerClose, saved: _vm.onDesignerSaved },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.printDialogVisible,
            title: "打印预览",
            width: "90%",
            footer: null,
            wrapClassName: "print-dialog-modal",
          },
          on: {
            cancel: function ($event) {
              _vm.printDialogVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "print-dialog-container" }, [
            _c("div", { staticClass: "print-settings" }, [
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("打印机")]),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "选择打印机" },
                      model: {
                        value: _vm.selectedPrinter,
                        callback: function ($$v) {
                          _vm.selectedPrinter = $$v
                        },
                        expression: "selectedPrinter",
                      },
                    },
                    _vm._l(_vm.printerList, function (printer) {
                      return _c("a-select-option", { key: printer }, [
                        _vm._v(_vm._s(printer)),
                      ])
                    }),
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { size: "small", icon: "reload" },
                      on: { click: _vm.refreshPrinters },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("份数")]),
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 1, max: 99 },
                    model: {
                      value: _vm.printCopies,
                      callback: function ($$v) {
                        _vm.printCopies = $$v
                      },
                      expression: "printCopies",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("方向")]),
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.printOrientation,
                        callback: function ($$v) {
                          _vm.printOrientation = $$v
                        },
                        expression: "printOrientation",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: "portrait" } }, [
                        _vm._v("纵向"),
                      ]),
                      _c("a-radio", { attrs: { value: "landscape" } }, [
                        _vm._v("横向"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("纸张")]),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { defaultValue: "A4" },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "A4" } }, [
                        _vm._v("A4"),
                      ]),
                      _c("a-select-option", { attrs: { value: "A5" } }, [
                        _vm._v("A5"),
                      ]),
                      _c("a-select-option", { attrs: { value: "B5" } }, [
                        _vm._v("B5"),
                      ]),
                      _c("a-select-option", { attrs: { value: "Letter" } }, [
                        _vm._v("Letter"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "print-actions" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "printer", block: "" },
                      on: { click: _vm.doPrint },
                    },
                    [_vm._v("打印")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "print-preview-area" }, [
              _c("div", { staticClass: "preview-toolbar" }, [
                _c("span", [_vm._v("共 1 页")]),
              ]),
              _c(
                "div",
                { ref: "printPreviewContent", staticClass: "preview-content" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "preview-paper",
                      style: {
                        transform: `scale(${_vm.zoomLevel / 100})`,
                        transformOrigin: "top center",
                      },
                    },
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.previewHtml) },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }